import { DirectoryIcon, DirectoryIcon2 } from "../icon_templates/icons";
import { AddFileIcon } from "./AddIconToNodes";

export const AddKeyToNodes = (nodes, parentKey='') => {
    return nodes.map((node, index) => {
        // Construct the key based on the parent's key and the current index
        const currentKey = parentKey ? `${parentKey}-${index}` : `${index}`;
        
        // Create a new object with the key property
        const newNode = {
            ...node,
            key: currentKey,
            //label: <span title={node.label}>{node.label}</span>,
            title : node.label,
            icon: node.is_dir ? <DirectoryIcon2 IconStyleClass="svg-icon svg-file-type-icon"/> : AddFileIcon(node.label,"svg-icon svg-file-type-icon"),
            expandIcon : "X"
        };

        // If the node has children, recursively add keys to them
        if (newNode.children && newNode.children.length > 0) {
            newNode.children = AddKeyToNodes(newNode.children, currentKey);
        }else{
            newNode.children = node.is_dir ? [{}] : [];
        }

        //console.log(newNode);
        return newNode;
    });


    //console.log(nodes);
}